/**
 * @description Get icon for an event type
 *
 * @param {string} type - Event type
 * @returns Icon string
 */
function getIcon(type) {
	switch (type) {
	case ('appSend'):
		return 'envelope';
	case ('startTrip'):
		return 'play';
	case ('stopTrip'):
		return 'stop';
	case ('collected'):
		return 'import';
	case ('delivered'):
		return 'export';
	case ('received'):
		return 'mobile-phone';
	case ('accepted'):
		return 'tick';
	case ('rejected'):
		return 'cross';
	case ('loaded'):
	case ('inbound'):
		return 'import';
	case ('unloaded'):
	case ('outbound'):
		return 'export';
	case ('setDriver'):
		return 'person';
	case ('ediInstructionReceived'):
		return 'globe';
	case ('ediInstructionSent'):
		return 'globe';
	case ('ediTrackAndTraceSent'):
		return 'globe';
	case ('created'):
		return 'plus';
	default:
		return '';
	}
}

export default { getIcon };